"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@emotion/core");
const design_system_1 = require("@zapier/design-system");
const AppList_1 = __importDefault(require("../AppList"));
const FeaturedAppButton_1 = __importDefault(require("../FeaturedAppButton"));
const sidebarCss = core_1.css `
  display: grid;
  grid-gap: 20px;
  grid-template-columns: 1fr;

  @media screen and (min-width: 575px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media screen and (min-width: 800px) {
    grid-template-columns: 1fr;
  }

  width: 100%;
`;
function Sidebar({ featuredApps, onSelect }) {
    return (core_1.jsx("div", { css: sidebarCss }, featuredApps.map(app => (core_1.jsx(FeaturedAppButton_1.default, { app: app, key: app.key, onClick: onSelect })))));
}
const containerCss = core_1.css `
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: 20px;
  padding: 20px;
  border-bottom-right-radius: 10px;
  border-bottom-left-radius: 10px;
  text-align: left;

  @media screen and (min-width: 800px) {
    grid-template-columns: 1.75fr 1fr;
  }

  background-color: ${design_system_1.Colors.white};
`;
function JobCentricAppPicker({ apps, featuredApps, onSearchQueryChange, searchQuery, onSelect, onNoAppFound, isTrigger, }) {
    const onAppListItemSelect = (key) => {
        const eventLocation = searchQuery ? 'search_results' : 'default_apps';
        onSelect(key, eventLocation);
    };
    const onSidebarAppSelect = (key) => {
        const eventLocation = 'jobs_centric_app_picker_sidebar';
        onSelect(key, eventLocation);
    };
    return (core_1.jsx("div", { css: containerCss },
        core_1.jsx(AppList_1.default, { apps: apps, isTrigger: isTrigger, onNoAppFound: onNoAppFound, onSearchQueryChange: onSearchQueryChange, onSelect: onAppListItemSelect, searchQuery: searchQuery }),
        core_1.jsx(Sidebar, { featuredApps: featuredApps, onSelect: onSidebarAppSelect })));
}
exports.default = JobCentricAppPicker;
